"use strict";

module.exports = {
  hasTexture1: false,
  hasTextureCube1: false,

  enableLights: false,
  useReflection: false,

  // picking configs
  enablePicking: false,
  hasPickingColors: false,

  // fog configuration
  hasFog: false
};
//# sourceMappingURL=default-uniforms.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/deprecated/shaderlib/default-uniforms.js
// module id = 755
// module chunks = 0